module.exports = __webpack_public_path__ + "img/btn_partner.1775439203884.png";